import { Form } from 'antd';
import { ContentFilters } from 'components';
import dayjs from 'dayjs';
import { NotificationFilterForm } from 'features/notification/components/notification-filter-form/notification-filter-form';
import {
  NotificationFilterFormPaginated,
  NotificationFilterFormValues,
} from 'features/notification/components/notification-filter-form/type';
import { NotificationViewTable } from 'features/notification/components/notification-table/notification-view-table-data';
import { NotificationListTopBar } from 'features/notification/components/top-bar/notification-item-top';
import { useGetNotificationList } from 'features/notification/use-cases/get-notification-list';
import { usePaginationParams } from 'hooks';
import { omit } from 'lodash';
import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { formatDate } from 'utils/date';
const initialFilterValues: NotificationFilterFormValues = {
  notificationtypeid: undefined,
  devicetypeid: undefined,
  title: undefined,
  date: [undefined, undefined],
};

export const NotificationView = () => {
  const { params, updateParams, resetPage } =
    usePaginationParams<NotificationFilterFormPaginated>({
      page: 1,
      size: 10,
      ...initialFilterValues,
    });
  const preparePayload = (paramsw: NotificationFilterFormPaginated) => {
    const createdAtFrom = paramsw.date?.[0];
    const createdAtTo = paramsw.date?.[1];

    return {
      ...omit(params, ['date']),
      fromDate: createdAtFrom
        ? formatDate({
            date: dayjs(createdAtFrom).startOf('day'),
            format: 'isoDate',
          })
        : undefined,
      toDate: createdAtTo
        ? formatDate({
            date: dayjs(createdAtTo).startOf('day'),
            format: 'isoDate',
          })
        : undefined,
    };
  };
  const { data, isFetching, refetch } = useGetNotificationList(
    preparePayload(params),
  );
  const handleFiltersChange = (values: NotificationFilterFormValues) => {
    updateParams(values);
    resetPage();
  };
  const formId = 'users-with-wallet-filters-form';
  const [form] = Form.useForm<NotificationFilterFormValues>();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === '/notification') {
      document.body.style.overflow = 'visible';
    } else {
      document.body.style.overflow = 'hidden';
    }
  }, [location]);

  return (
    <div>
      <NotificationListTopBar
        refetch={refetch}
        form={form}
        resetPage={resetPage}
        handleFilter={handleFiltersChange}
        initialValues={initialFilterValues}
      />
      <ContentFilters formId={formId}>
        <NotificationFilterForm
          form={form}
          formId={formId}
          handleFilter={handleFiltersChange as any}
          initialValues={initialFilterValues as any}
        />
      </ContentFilters>
      <NotificationViewTable
        isLoading={isFetching}
        data={data}
        tableParams={params}
        updateParams={updateParams}
        refetch={refetch}
      />

      <Outlet />
    </div>
  );
};
